import { ShieldCheck } from 'lucide-react'

export function PrivacyPolicyPage() {
  return (
    <div className="bg-background-dark min-h-screen pb-24 pt-40">
      <div className="container max-w-[800px] mx-auto px-6">
        <div className="flex items-center gap-3 mb-8">
          <ShieldCheck className="w-10 h-10 text-game-primary" />
          <h1 className="text-white text-3xl md:text-4xl font-black">Privacy Policy</h1>
        </div>
        
        <p className="text-slate-400 mb-8">Last updated: February 4, 2026</p>

        <div className="space-y-8 text-slate-300">
          <section>
            <h2 className="text-white text-2xl font-bold mb-4">1. Introduction</h2>
            <p className="leading-relaxed">
              Welcome to Polytoria ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">2. Information We Collect</h2>
            <p className="leading-relaxed mb-4">We collect information you provide directly to us, including:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Account information (username, email address, password)</li>
              <li>Profile information (avatar, bio, preferences)</li>
              <li>Payment information (processed securely through third-party providers)</li>
              <li>Communications (messages, support requests)</li>
              <li>User-generated content (games, assets, comments)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">3. How We Use Your Information</h2>
            <p className="leading-relaxed mb-4">We use the information we collect to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send technical notices, updates, and support messages</li>
              <li>Respond to your comments and questions</li>
              <li>Monitor and analyze trends, usage, and activities</li>
              <li>Detect, investigate, and prevent security incidents</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">4. Information Sharing</h2>
            <p className="leading-relaxed">
              We do not sell your personal information. We may share your information with third parties only in the following circumstances: with your consent, to comply with legal obligations, to protect our rights and safety, or with service providers who assist in our operations.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">5. Data Security</h2>
            <p className="leading-relaxed">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">6. Your Rights</h2>
            <p className="leading-relaxed mb-4">You have the right to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Access and receive a copy of your personal data</li>
              <li>Rectify inaccurate personal data</li>
              <li>Request deletion of your personal data</li>
              <li>Object to processing of your personal data</li>
              <li>Data portability</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">7. Children's Privacy</h2>
            <p className="leading-relaxed">
              We take children's privacy seriously. Users under 13 require parental consent. We implement additional safeguards for younger users, including restricted chat features and enhanced privacy settings.
            </p>
          </section>

          <section>
            <h2 className="text-white text-2xl font-bold mb-4">8. Contact Us</h2>
            <p className="leading-relaxed">
              If you have any questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:privacy@polytoria.io" className="text-game-primary hover:underline">
                privacy@polytoria.io
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
